import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import TitleHeader from "../../components/TitleHeader";

const FAQ_SECTIONS = [
  ["workflow", 1],
  ["dashboard", 2],
  ["solver", 2],
  ["team", 2],
  ["invite", 1],
  ["availability", 2],
  ["company", 2],
  ["planning", 2],
  ["shiftplan", 2],
];

const FAQ = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const questionSx = {
    fontSize: "1rem",
    mb: 1.5,
    color: "text.primary",
    fontWeight: 600,
  };
  const answerSx = {
    fontSize: "1rem",
    color: "text.primary",
    mb: 2.5,
    pb: 2,
    borderBottom: "1px solid",
    borderColor: "divider",
    whiteSpace: "pre-line",
  };

  return (
    <Box m={2}>
      <TitleHeader title={t("faq.title")} subtitle={t("faq.subtitle")} />
      <Paper
        elevation={5}
        sx={{
          maxHeight: "calc(85vh - 85px)",
          overflowY: "auto",
          p: 2,
          bgcolor: "background.box",
          borderRadius: 1,
        }}
      >
        {FAQ_SECTIONS.map(([section, count]) => (
          <Accordion
            key={section}
            disableGutters
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              "& + &": { mt: 1.5 },
              "& .MuiAccordionSummary-root": {
                bgcolor: "action.hover",
                "&:hover": { bgcolor: "action.selected" },
              },
              "&.Mui-expanded .MuiAccordionSummary-root": {
                bgcolor: "action.selected",
              },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5" sx={{ fontWeight: 700, color: "text.primary" }}>
                {t(`faq.sections.${section}.title`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {Array.from({ length: count }, (_, index) => index + 1).map((number) => (
                <React.Fragment key={`${section}-${number}`}>
                  <Typography sx={questionSx}>
                    {t(`faq.sections.${section}.q${number}`)}
                  </Typography>
                  <Typography sx={answerSx}>
                    {t(`faq.sections.${section}.a${number}`)}
                  </Typography>
                </React.Fragment>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}

        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" sx={{ mt: 1, color: "text.primary" }}>
          {t("faq.contact")}
        </Typography>
        <Typography variant="h5" sx={{ mt: 1 }}>
          <a
            href="mailto:info@timetab.ch"
            style={{ color: theme.palette.success.main, textDecoration: "underline" }}
          >
            info@timetab.ch
          </a>
        </Typography>
      </Paper>
    </Box>
  );
};

export default FAQ;
